import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: 'Come ricevo il materiale?',
  a: "Immediatamente dopo l'acquisto, riceverai un link di download diretto via email. Non c'è attesa: puoi iniziare la tua prima ricetta tra 5 minuti."
}, {
  q: "È adatto anche se prendo già l'Eutirox o il Tirosint?",
  a: "Assolutamente sì. Il nostro protocollo alimentare è studiato per lavorare in sinergia con la tua terapia farmacologica, aiutando il tuo corpo a metabolizzare meglio gli ormoni e a ridurre l'infiammazione di base."
}, {
  q: 'Le ricette sono difficili o costose?',
  a: 'No. Abbiamo selezionato solo ingredienti della nostra dieta mediterranea che trovi in qualsiasi supermercato italiano. Ogni piatto è pensato per essere pronto in 15-20 minuti.'
}, {
  q: 'Cosa succede se ho dubbi durante il percorso?',
  a: 'Siamo qui per te. Puoi scriverci in qualsiasi momento alla nostra mail di assistenza dedicata kitonline27@gmail.com e il nostro team ti risponderà entro 24 ore.'
}, {
  q: 'Il pagamento è sicuro?',
  a: 'Utilizziamo le piattaforme di pagamento criptate più sicure al mondo. Il tuo acquisto è protetto al 100% e i tuoi dati non verranno mai condivisi.'
}, {
  q: 'Posso usare queste ricette se ho altre intolleranze alimentari?',
  a: 'Sì. Molte ricette sono già senza glutine e lattosio, e nel kit troverai suggerimenti per adattare ogni piatto alle tue esigenze specifiche.'
}, {
  q: 'Quanto tempo ci vuole per vedere i primi risultati?',
  a: "La maggior parte delle donne nota una riduzione del gonfiore e un aumento dell'energia entro i primi 7-10 giorni. I risultati sulla bilancia e sulla pelle diventano evidenti dopo 3-4 settimane di applicazione costante."
}, {
  q: 'Devo eliminare completamente alcuni cibi?',
  a: 'Non si tratta di eliminare, ma di scegliere meglio. Il protocollo ti insegna quali alimenti supportano la tua tiroide e quali la rallentano, permettendoti di fare scelte consapevoli senza privazioni estreme.'
}, {
  q: 'È adatto anche per chi ha il Morbo di Basedow (ipertiroidismo)?',
  a: "Il kit è specificamente progettato per l'ipotiroidismo e Hashimoto. Se hai ipertiroidismo, ti consigliamo di consultare il tuo endocrinologo prima di applicare il protocollo."
}, {
  q: 'Posso condividere il materiale con amiche o familiari?',
  a: 'Il kit è per uso personale. Se vuoi regalarlo, puoi acquistare una copia aggiuntiva. Rispettare il copyright ci permette di continuare a creare risorse di qualità a prezzi accessibili.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-8 px-4 bg-brand-bg" data-id="element-43">
      <div className="max-w-2xl mx-auto" data-id="element-44">
        <div className="text-center mb-8" data-id="element-45">
          <h2 className="text-xl sm:text-2xl font-heading font-bold text-brand-primary" data-id="element-46">
            ❓ DOMANDE FREQUENTI (FAQ)
          </h2>
        </div>

        <div className="space-y-2" data-id="element-47">
          {faqs.map((faq, i) => <div key={i} className="bg-white border border-brand-border rounded-lg overflow-hidden" data-id="element-48">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-5 py-4 text-left flex justify-between items-center" data-id="element-49">
                <span className="font-bold text-brand-primary text-sm pr-4" data-id="element-50">
                  {faq.q}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-brand-primary transition-transform shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-51" />
              </button>

              {openIndex === i && <div className="px-5 pb-4 pt-0 text-sm text-brand-text leading-relaxed" data-id="element-52">
                  {faq.a}
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}